<template>
	<app-page>
		<app-heading title="String Categories">
			<template v-slot:left>
				<app-button v-if="$ravello.can('website.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					outlined
					small
					:to="{ name: 'string-category', params: { category: 'new' } }"
				>Add Category</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="categories"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchCategories"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('website.put')"
							color="secondary"
							:to="{ name: 'string-category', params: { category: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('website.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove category <b>${item.name}</b>?`"
							title="Remove Category"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'string-category', params: { category: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			categories: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchCategories(pagination) {
			const request = this.$ravello.request()
				.v(2)
				.to('stringcategories')
				.fromPagination(pagination)

			try {
				this.categories = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('stringcategories')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
